import { render } from "./entry-stacked.vue?vue&type=template&id=fc008dba&scoped=true"
import script from "./entry-stacked.vue?vue&type=script&lang=js"
export * from "./entry-stacked.vue?vue&type=script&lang=js"

import "./entry-stacked.vue?vue&type=style&index=0&id=fc008dba&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc008dba"]])

export default __exports__